<template>
  <Modal
    v-model="_value"
    width="400"
    title="通立设置车辆参数"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <Form ref="setDriverCardParamsRef" v-model="setDriverCardParams" :label-width="140">
      <FormItem prop="registrationNum" label="车牌号">
        <Input v-model="setDriverCardParams.registrationNum" style="width: 180px;" placeholder="请输入车牌号">
        </Input>
      </FormItem>
      <FormItem prop="registrationColor" label="车牌颜色">
<!--        <Input v-model="setDriverCardParams.registrationColor" placeholder="请输入司机卡号">-->
<!--        </Input>-->
          <Select v-model="setDriverCardParams.registrationColor" style="width: 180px;">
            <Option v-for="item in registrationColorOptions" :value="item.value" :key="item.value">
              {{item.name}}
            </Option>
          </Select>
      </FormItem>
      <FormItem prop="vehicleType" label="车辆类型">
        <Input v-model="setDriverCardParams.vehicleType" style="width: 180px;" placeholder="请输入车辆类型">
        </Input>
      </FormItem>
<!--      <FormItem prop="terminalNum" label="手机号（终端主机号）">-->
<!--        <Input v-model="setDriverCardParams.terminalNum" style="width: 180px;" placeholder="请输入车辆类型">-->
<!--        </Input>-->
<!--      </FormItem>-->
      <FormItem prop="engineNum" label="发动机号">
        <Input v-model="setDriverCardParams.engineNum" style="width: 180px;" placeholder="请输入发动机号">
        </Input>
      </FormItem>
      <FormItem prop="engineNum" label="车架号">
        <Input v-model="setDriverCardParams.vin" style="width: 180px;" placeholder="请输入车架号">
        </Input>
      </FormItem>
      <Button type="primary" @click="onCleanDriverCardParams" style="margin-right: 5px;">清空</Button>
      <Button type="primary" @click="onSendDriverCardParams">发送</Button>
    </Form>
  </Modal>
</template>

<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'tlsetdrivervehicleinfomodal',
  components: {

  },
  props: {
    initValue: null,
    terminalNumValue: null,
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      setDriverCardParams: {
        id: null,
        registrationNum: null,
        registrationColor: null,
        vehicleType: null,
        // terminalNum: null,
        engineNum: null,
        vin: null,
      },
      registrationColorOptions: [
        {name: '蓝色', value: 1},
        {name: '黄色', value: 2},
        {name: '黑色', value: 3},
        {name: '白色', value: 4},
        {name: '绿色', value: 5},
        {name: '黄绿色', value: 6},
        {name: '渐变绿', value: 7},
      ],
    }
  },
  methods: {
    ...mapActions([
      'VehicleInfoServ_SearchByName'
    ]),
    visibleChange (val) {
      if (val) {
        this.setDriverCardParams.id = this._initValue
        this.setDriverCardParams.registrationNum = null
        this.setDriverCardParams.registrationColor = null
        this.setDriverCardParams.vehicleType = null
        // this.setDriverCardParams.terminalNum = this._terminalNumValue
        this.setDriverCardParams.engineNum = null

        store.dispatch('PositioningDeviceInfoServ_SearchByName',{
          params:{
            name: this._terminalNumValue
          },
          urlparams:null,
        }).then(res =>{
          if (store.getters.get_PositioningDeviceInfo_SearchByNameResult && store.getters.get_PositioningDeviceInfo_SearchByNameResult.length >0){
            console.log(store.getters.get_PositioningDeviceInfo_SearchByNameResult)
            let vehicleInfoId = store.getters.get_PositioningDeviceInfo_SearchByNameResult[0].vehicleInfoId
            if (vehicleInfoId!=null){
              store.dispatch('VehicleInfoServ_GetDetail',{
                params:{
                  id: vehicleInfoId
                },
                urlparams:null
              }).then(res =>{
                if (store.getters.get_VehicleInfo_GetDetailResult){
                  let vehicleInfo = store.getters.get_VehicleInfo_GetDetailResult
                  if (vehicleInfo.registrationNum) {
                    this.setDriverCardParams.registrationNum = vehicleInfo.registrationNum
                  }
                  if (vehicleInfo.vehicleType != null){
                    this.setDriverCardParams.vehicleType = vehicleInfo.vehicleType.name
                  }
                  if (vehicleInfo.engineNum !=null){
                    this.setDriverCardParams.engineNum = vehicleInfo.engineNum
                  }
                  if (vehicleInfo.vin !=null){
                    this.setDriverCardParams.vin = vehicleInfo.vin
                  }
                }
              }).catch(err =>{

              })

            } else {
              console.log(store.getters.get_PositioningDeviceInfo_SearchByNameResult[0].installOrderId)
              store.dispatch('InstallOrderServ_GetDetail',{
                params:{
                  id: store.getters.get_PositioningDeviceInfo_SearchByNameResult[0].installOrderId
                },
                urlparams:null
              }).then(res =>{
                if (store.getters.get_InstallOrder_GetDetailResult){
                  let installOrder = store.getters.get_InstallOrder_GetDetailResult
                  if (installOrder.tempVehicleInfo.registrationNum) {
                    this.setDriverCardParams.registrationNum = installOrder.tempVehicleInfo.registrationNum
                  }
                  if (installOrder.tempVehicleInfo.vehicleType != null){
                    this.setDriverCardParams.vehicleType = installOrder.tempVehicleInfo.vehicleType.name
                  }
                  if (installOrder.tempVehicleInfo.engineNum !=null){
                    this.setDriverCardParams.engineNum = installOrder.tempVehicleInfo.engineNum
                  }
                  if (installOrder.tempVehicleInfo.vin !=null){
                    this.setDriverCardParams.vin = installOrder.tempVehicleInfo.vin
                  }
                }
              }).catch(err =>{

              })
            }
          }
        }).catch(err =>{

        })

      }
    },
    onCleanDriverCardParams () {
      this.setDriverCardParams.registrationNum = null
      this.setDriverCardParams.registrationColor = null
      this.setDriverCardParams.vehicleType = null
      // this.setDriverCardParams.terminalNum = null
      this.setDriverCardParams.engineNum = null
      this.setDriverCardParams.vin = null
    },
    onSendDriverCardParams () {
      //修改车牌号、车牌颜色黄、车架号、车辆类型、发动机号指令：$BUS,,,粤 A123456,2,,,LGAG541239874561,大型货运汽车,FDJ123456
      //(车牌颜色说明：1 蓝，2 黄，3 黑，4 白，5 绿，6 黄绿，7 渐变绿，9 其他)
      let content = '$BUS,,,'
      if (this.setDriverCardParams.registrationNum !=null && this.setDriverCardParams.registrationNum != ''){
        content += this.setDriverCardParams.registrationNum + ','
      }
      if (this.setDriverCardParams.registrationColor !=null && this.setDriverCardParams.registrationColor != ''){
        content += this.setDriverCardParams.registrationColor + ','
      }
      content += ',,'
      if (this.setDriverCardParams.vin !=null && this.setDriverCardParams.vin != ''){
        content += this.setDriverCardParams.vin + ','
      }
      if (this.setDriverCardParams.vehicleType !=null && this.setDriverCardParams.vehicleType != ''){
        content += this.setDriverCardParams.vehicleType + ','
      }
      if (this.setDriverCardParams.engineNum !=null && this.setDriverCardParams.engineNum != ''){
        content += this.setDriverCardParams.engineNum + ','
      }
      // if (this.setDriverCardParams.terminalNum !=null && this.setDriverCardParams.terminalNum != ''){
      //   content += '手机号='+this.setDriverCardParams.terminalNum + ',' + '终端ID='+this.setDriverCardParams.terminalNum.substring(4) + ','
      // }
      content = content.substring(0,content.length-1)
      console.log(content)
      store.dispatch('NetCommandServ_SendCommand', {
        // params: { id: this._initValue, content: '#_ZTTtsSet;终端设置;'+'车牌号='+this.setDriverCardParams.registrationNum+',车牌颜色='+this.setDriverCardParams.registrationColor+',车辆类型='+this.setDriverCardParams.vehicleType+'$', urgent: true }
        params: { id: this._initValue, content: content, urgent: true }
      }).then(() => {
        this.$Message.success('发送成功')
      }).catch(err => {
        this.$Message.error(err)
      })
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _terminalNumValue: {
      get () {
        return this.terminalNumValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
